import React from "react";
import Hero from "../components/Hero/Hero";
// import NatureVid from "../assets/video/dubaiVideo.mp4";
import dubai from "../assets/video/dubai.mp4";
import BlogsComp from "../components/Blogs/BlogsComp";
import Places from "../components/Places/Places";
import Testimonial from "../components/Testimonial/Testimonial";
import OrderPopup from "../components/OrderPopup/OrderPopup";
import TravelSection from "../components/Travel/TravelSection";
import TravelDeals from "../components/Travel/TravelDeals";
import ServicesCard from "../components/Travel/ServiceCard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GlobalLoader from "../util/GlobalLoader";

const Home = () => {
  const [orderPopup, setOrderPopup] = React.useState(false);
  const [loading, setLoading] = React.useState(true); // State to track if video is loading

  const handleOrderPopup = () => {
    setOrderPopup(!orderPopup);
  };

  // Handle when video has loaded
  const handleVideoLoad = () => {
    setLoading(false); // Video has finished loading, hide the loader
  };

  return (
    <>
      <div className="bg-white">
        <div className="h-[800px] z-20 relative">
          {loading && (
            // Loader animation while the video is loading
            <div className="flex justify-center items-center h-screen fixed inset-0 z-50 bg-black bg-opacity-80">
              <GlobalLoader />
            </div>
          )}

          <video
            autoPlay
            loop
            muted
            className="absolute right-0 top-0 h-[860px] w-full pointer-events-none object-cover z-[-1]"
            onCanPlay={handleVideoLoad} // Video is ready to play
          >
            <source src={dubai} type="video/mp4" />
          </video>
          {/* Overlay to fade the video */}
          <div className="absolute top-10 right-0 h-[820px] w-full bg-black bg-opacity-50 z-0"></div>
          {/* Hero component should come over the top of the overlay */}
          <div className="relative z-10">
            <Hero handleOrderPopup={handleOrderPopup} />
          </div>
        </div>

        <TravelSection />
        <TravelDeals />
        <ServicesCard />
        {/* <Places handleOrderPopup={handleOrderPopup} /> */}
        {/* <BannerPic img={BannerImg} /> */}
        {/* <BlogsComp /> */}
        {/* <Banner /> */}
        {/* <BannerPic img={Banner2} /> */}
        <Testimonial />
        <OrderPopup orderPopup={orderPopup} setOrderPopup={setOrderPopup} />
      </div>
      <ToastContainer />
    </>
  );
};

export default Home;
